import { useEffect, useState } from 'react';
import { scoreRating } from '../../../utils/roundup';

export default function ITEM({ item, index, handleValueBlur, previousRoundups = [], isCompleted }) {
  const [value, setValue] = useState(item.value ?? 0);
  useEffect(() => { setValue(item.value ?? 0); }, [item.value, item.name]);
  const history = previousRoundups.map(roundup => ({ roundup, item: roundup.roundup_scorecard?.find(score => score.name === item.name) }));
  const scores = history.filter(entry => entry.item && Number.isFinite(Number(entry.item.value)));
  const average = scores.length ? Math.round(scores.reduce((sum, entry) => sum + Number(entry.item.value), 0) / scores.length) : '—';
  const rating = scoreRating(value, item.aim);
  return <tr>
    <th scope="row">{item.name}</th><td>{item.aim}</td><td>{average}</td>
    {history.map(entry => {
      const rating = entry.item ? scoreRating(entry.item.value, entry.item.aim) : { className: '', label: 'No score' };
      return <td key={entry.roundup._id} className={rating.className} title={rating.label}>{entry.item?.value ?? '—'}</td>;
    })}
    <td className={rating.className} title={rating.label}><input type="number" aria-label={`This week: ${item.name}`} value={value} onChange={event => setValue(event.target.value)} onBlur={() => handleValueBlur(index, value)} disabled={isCompleted} /></td>
  </tr>;
}
